/******************************************************************
 * Archivo : client/src/mutations/updateUser.js
 * Proyecto: CB30
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  mutation UpdateUser(
    $id: ID!
    $email: String!
    $nombre: String!
    $apellido: String!
    $active: Boolean!
    $validated: Boolean!
    $tipoPerfil: Int
    $roleId: ID!
  ) {
    updateUser(
      id: $id
      email: $email
      nombre: $nombre
      apellido: $apellido
      active: $active
      validated: $validated
      tipoPerfil: $tipoPerfil
      roleId: $roleId
    ) {
      id
      email
      nombre
      apellido
      active
      validated
      tipoPerfil

      roles {
        id
        code
        label
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/mutations/updateUser.js